import "$styles/index.scss"

import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Website loaded :)", components)
